var lists=[
    {
        name:'行业资讯',
        subname:[
            '业界动态',
            '收购融资',
            '门户动态',
            '搜索引擎',
            '网络游戏',
            '电子商务',
            '广告传媒',
            '厂商开发'
        ],
        isActive:false
    },
    {
        name:'站长在线',
        subname:[
            '站长报道',
            '好站推荐',
            '站长聚会',
            '站长访谈',
            '站长茶馆',
            '网站排行',
        ],
        isActive:false
    },
    {
        name:'网站运营',
        subname:[
            '建站经验',
            '策划盈利',
            '搜索优化',
            '网站推广',
            '免费资源',
        ],
        isActive:false
    },
    {
        name:'设计在线',
        subname:[
            '酷站推荐',
            '网页设计',
            'WEB标准',
            '视频处理',
            '设计活动',
        ],
        isActive:false
    },
    {
        name:'网络编程',
        subname:[
            'Asp编程',
            'Php编程',
            '.Net编程',
            'Xml编程',
            'Access',
            'Mssql',
            'Mysql',
        ],
        isActive:false
    },
    {
        name:'联盟资讯',
        subname:[
            '联盟动态',
            '联盟介绍',
            '联盟点评',
            '网赚技巧',
        ],
        isActive:false
    },
    {
        name:'服务器',
        subname:[
            'Web服务器',
            'Ftp服务器',
            'Mail服务器',
            'Dns服务器',
            'Win服务器',
            'Linux服务器',
            '安全防护',
            '虚拟主机',
        ],
        isActive:false
    },
];

var get={
    byId(id){
        return document.getElementById(id);
    },
    byClass(sClass,oParent){
        var aClass=[];
        var reClass=new RegExp("(^|\\s)" + sClass + "(\\s|$)");
        var aElem=this.byTagName("*",oParent);
        for(var i=0;i<aElem.length;i++) reClass.test(aElem[i].className) && aClass.push(aElem[i]);
        return aClass;
    },
    byTagName(elem,obj){
        return (obj||document).getElementsByTagName(elem);
    }
}


export {lists, get};